module.exports = __webpack_public_path__ + "img/momo_home_bg_3.5af4471d.png";